import React from 'react';
import ReactDOM from 'react-dom';

// Portalled for the same reason as ErrorPopup: a fixed overlay mounted inside a
// transformed ancestor centres on that ancestor, not the viewport.
const ProcessingPopup = ({message}) => {
  return ReactDOM.createPortal(
    <div className="popup">
    <div className="popup-content">
    <div  className="text-center pt-2" >
    <img src="media/loader1.svg" className="w-10"  />
    </div>
      <div className="text-center mt-2 ev-fs-12 ev-bold-reg"><p>{message}</p></div>
    </div>
    </div>,
    document.body
  );
};

export default ProcessingPopup;
